import type { Translation } from '../types.ts';
import type en from '../en/dashboard.ts';

export default {
    title: 'Dashboard',
    storage: {
        full: 'Opslag {percent}% vol: {used} van {quota}.',
        refused: 'Zodra de opslag vol is, worden nieuwe uploads en back-ups geweigerd.',
    },
    shop: {
        heading: 'Webshop, {month}',
        allOrders: 'Alle bestellingen →',
        loadFailed: 'De webshopcijfers konden niet worden geladen: {error}',
        noRevenue: 'Nog geen omzet',
        revenueInclVat: '{revenue} incl. btw',
        ordersThisMonth: 'Bestellingen deze maand',
        toShip: 'Te verzenden',
        toShipHint: 'Betaald, nog niet verzonden',
        totalOrders: 'Bestellingen totaal',
        totalOrdersHint: 'Sinds de start van de webshop',
        newCustomers: 'Nieuwe klanten',
        newCustomersHint: 'Accounts deze maand',
        outOfStock: 'Uitverkocht',
        outOfStockHint: 'Producten in de verkoop',
    },
    traffic: {
        heading: 'Laatste 7 dagen',
        fullStatistics: 'Alle statistieken →',
        views: 'Weergaven',
        uniqueVisitors: 'Unieke bezoekers',
        sessions: 'Sessies',
        avgDwell: 'Gem. verblijfsduur',
        pageviews: 'Paginaweergaven',
    },
    duration: {
        ms: '{n} ms',
        seconds: '{n} s',
        minutes: '{m} min {s} s',
    },
} satisfies Translation<typeof en>;
